import { render, staticRenderFns } from "./WalletAssetsList.vue?vue&type=template&id=65b02e02&"
import script from "./WalletAssetsList.vue?vue&type=script&lang=js&"
export * from "./WalletAssetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports